
import axios from 'axios';
import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const DataContext = createContext({});
const URL = {
  excel: 'http://172.25.0.23:5000/wpu/phones/data/all',
  json: '/wp-content/phones/data/PhoneDirectory.json',
  wpu: 'https://wpu.edu.sy/wp-content/phones/data/phoneDirectory.json'
};

export const ContextProvider = ({ children }) => {
  
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);
  const [phoneNames, setPhoneNames]=useState([])
  const [lastId, setLastId]=useState(0);

  const getData = useCallback(async () => {
    const res = await axios.get(URL.json,{
      headers:{
        'Access-Control-Allow-Origin': ["*","http://wpu.edu.sy","https://wpu.edu.sy"],
        'Content-Type': 'application/json',
        'mode':'no-core'
      }
    });
    return res.data;
  },[]);

  useEffect(() => {
    const fetchAPI = async () => {
      const mydata = await getData();
      setData(mydata.orgDivisions);
      setFilteredData(mydata.orgDivisions)
      setLastId(mydata.orgDivisions.length)
      setPhoneNames(()=>{
        const temp = [];
        mydata.orgDivisions.forEach(element=>{
            element.phoneNumbers.forEach((depName)=>{
            temp.push({...depName,divisionName:element.divisionName})
            })
        })
        return temp
      })
    };

    fetchAPI();
  }, [getData]);

  return (
    <DataContext.Provider value={{filteredData, setFilteredData, data, setData,
     phoneNames, lastId, setLastId}}>
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);